import { env } from '../env';
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Typography, Skeleton, Alert, Divider } from "@mui/material";
import ChoiceHistory from "../component/ChoiceHistory";
import { useState } from "react";
import { useEffect } from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";
import moment from "moment";
import "moment/locale/fr";
import { Box } from "@mui/system";
moment.locale("fr");

function Plannar({ setPage, page }) {
  const [planning, setPlanning] = useState(null);
  const [pickedDate, setPickedDate] = useState(new Date());

    useEffect(() => {
        const request = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            mode: "cors",
            body: JSON.stringify({
                LK: env.REACT_APP_LICENCE_KEY,
                ENVID: env.REACT_APP_ENV_ID,
                PlaceID: page.place.ID,
                AppointmentTypeID: page.motif.ID,
                PractitionerID: page.praticien.ID,
                From: new Date(pickedDate).toLocaleString() 
            })
        };
    fetch(
      `${env.REACT_APP_PROXY_BASE_URL}/practitioner/schedule`, request
    )
      .then((res) => res.json())
      .then((res) => {
        res.Schedule.length > 4
          ? setPlanning(res.Schedule.slice(0, 4))
          : setPlanning(res.Schedule);
      })
      .catch((err) => console.log("Schedule fetch error " + err));
  }, [pickedDate]);
  function handleScheduleClick(e, appointmentTimeFrom, appointmentTypeTo) {
    setPage({
      ...page,
      page: 4,
      date: appointmentTimeFrom,
      dateTo: appointmentTypeTo,
    });
  }

  // Permet de rendre les skeleton pendant le chargement des données.
  function renderSkeleton() {
    return (
      <Grid container spacing={2}>
        {/* Planning des horaires disponibles */}
        <Grid container item justifyContent="center">
          {/* Jour */}

          <Grid item xs>
            <Grid container direction="column" spacing={1} alignItems="center">
              <Skeleton width={200} height={90} />
              <Grid
                container
                direction="column"
                spacing={1}
                alignItems="center"
              >
                {/* Horaires */}
                <Skeleton width={90} height={65} />
                <Skeleton width={90} height={65} />
                <Skeleton width={90} height={65} />
                <Skeleton width={90} height={65} />
                <Skeleton width={90} height={65} />
                <Skeleton width={90} height={65} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container justifyContent="center" spacing={3}>
      {/* Rappel */}
      <ChoiceHistory page={page} setPage={setPage} />

      {/* Choix du rendez-vous */}
      <Grid
        item
        order={{ xs: 2, sm: 1 }}
        xs={12}
        md={6}
        justifyContent="center"
        my="50px"
      >
        <Grid container spacing={2}>
          {/* Titre */}
          <Grid item xs={12}>
            <Typography variant="h3" align="center">
              Choisissez un horaire
            </Typography>
          </Grid>

          {/* Planning des horaires disponibles */}
          <Grid container item justifyContent="center">
            {/* Jour */}
            {!planning ? (
              renderSkeleton()
            ) : planning.length === 0 ? (
              <Alert severity="warning">
                Il n'y a pas de créneau pour la date séléctionnée, veuillez en
                choisir une autre.
              </Alert>
            ) : (
              planning?.map((planning) => (
                <Grid item xs key={planning.Key}>
                  <Grid item>
                    <Typography variant="h6" align="center" gutterBottom>
                      {moment(planning.Key, "DD-MM-YYYY").format(
                        "ddd DD MM YYYY"
                      )}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    direction="column"
                    spacing={1}
                    alignItems="center"
                  >
                    {/* Horaires */}

                    {planning?.Value.map(
                      (range, i) => (
                        // isAvailable && (
                        <Grid item key={i} sm={6}>
                          <Button
                            variant="contained"
                            onClick={(e) =>
                              handleScheduleClick(e, range?.From, range?.To)
                            }
                          >
                            {moment(range?.From).format("HH[h] mm")}
                          </Button>
                        </Grid>
                      )
                      // )
                    )}
                  </Grid>
                </Grid>
              ))
            )}
          </Grid>
        </Grid>
        <Grid item mt={4}>
          <Box mb={2}>
            <Divider />
          </Box>
          <Typography align="center" variant="h6" mb={2}>
            Choisir une autre date
          </Typography>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid container justifyContent={"center"}>
              <Grid item sm={10} lg={8}>
                {/* <TextField fullWidth type={"date"}></TextField> */}
                <CalendarPicker
                  minDate={moment()}
                  date={moment(pickedDate)}
                  onChange={(newDate) => {
                    setPlanning(undefined);
                    setPickedDate(newDate);
                  }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Plannar;
